var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconPerson2 = function SvgIconPerson2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5a4.277 4.277 0 0 1 4.273 4.273 4.265 4.265 0 0 1-1.377 3.14 7.138 7.138 0 0 1 2.155 1.482 7.098 7.098 0 0 1 2.092 5.05v.183a.872.872 0 0 1-1.743 0v-.182c0-2.978-2.423-5.4-5.4-5.4a5.406 5.406 0 0 0-5.4 5.4v.182a.872.872 0 0 1-1.743 0v-.182c0-1.908.744-3.703 2.092-5.051a7.138 7.138 0 0 1 2.155-1.482l-.133-.13a4.263 4.263 0 0 1-1.244-3.01A4.277 4.277 0 0 1 9 1.5Zm0 1.743a2.533 2.533 0 0 0-2.53 2.53A2.533 2.533 0 0 0 9 8.303a2.533 2.533 0 0 0 2.53-2.53A2.533 2.533 0 0 0 9 3.243Z",
    fill: "#1B75E2",
    fillRule: "evenodd"
  })));
};

export default SvgIconPerson2;